import { Route, Routes, Navigate } from 'react-router-dom'
import { useContext, useEffect, useState, lazy } from 'react'
import { EARLY_ACCESS, STUDENT_PLUS } from '@/enums/userRoles'
import RoleMiddleware from '@/components/RoleMiddleware.jsx'
import { AuthContext } from '@/contexts/AuthContext'
import { isSquadAllowedForInternship } from '@/utils/squad-access'
import { useSquadNumber } from '@/hooks/useSquadNumber/useSquadNumber.js'
import PageLoader from '@/components/PageLoader'

const Internship = lazy(() => import('@/pages/Internship'))

const InternshipRouter = (
    <Routes>
        <Route
            index
            element={
                <RoleMiddleware roles={[STUDENT_PLUS]}>
                    <Internship />
                </RoleMiddleware>
            }
        />
    </Routes>
)

export default InternshipRouter
